import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AreaGate } from './shared/components/AreaGate';
import { getArea } from './shared/utils/subdomain';
import { ProdutosProvider } from './shared/contexts/ProdutosContext';
import { EstabelecimentosProvider } from './shared/contexts/EstabelecimentosContext';
import { CategoriasProvider } from './shared/contexts/CategoriasContext';
import { UsuariosProvider } from './shared/contexts/UsuariosContext';
import { UniversidadesProvider } from './shared/contexts/UniversidadesContext';
import { PedidosProvider } from './shared/contexts/PedidosContext';
import { ItensPedidosProvider } from './shared/contexts/ItensPedidosContext';
import { ClientesProvider } from './shared/contexts/ClientesContext';
import { ResponsaveisProvider } from './shared/contexts/ResponsaveisContext';
import { ResponsavelAlunoProvider } from './shared/contexts/ResponsavelAlunoContext';
import SecaoItens from './modules/cliente/components/SecaoItens';
import PedidoSucesso from './modules/caixa/pages/PedidoSucesso';
import GestaoEstabelecimentoMobile from './modules/administrador/pages/GestaoEstabelecimentoMobile';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ProtectedRoute } from './shared/components/ProtectedRoute';
import HomeResponsavel from './modules/cliente/pages/HomeResponsavel';



// Páginas
import HomePrincipal from './modules/cliente/pages/HomePrincipal';
import Home from './modules/cliente/pages/Home';
import HomeCliente from './modules/cliente/pages/HomeCliente';
import MesaParaPedido from './modules/operador/pages/MesaParaPedido';
import NovoPedido from './modules/operador/pages/NovoPedido';
import PerfilCliente from './modules/cliente/pages/PerfilCliente';
import CriarEstabelecimento from './modules/administrador/pages/CriarEstabelecimento';
import PedidoClique from './modules/cliente/pages/PedidoClique';
import PersonalizacaoLoja from './modules/administrador/pages/PersonalizacaoLoja';
import Start from './modules/cliente/pages/Start';
import CadastroAdmin from './modules/administrador/pages/CadastroAdmin';
import GerenciamentoPedidos from './modules/administrador/pages/GerenciamentoPedidos';
import CadastroMesas from './modules/administrador/pages/CadastroMesas';
import CadastroGarcons from './modules/administrador/pages/CadastroGarcons';
import CadastroProdutos from './modules/administrador/pages/CadastroProdutos';
import Dashboard from './modules/cozinha/pages/Dashboard';
import HistoricoPedidos from './modules/cliente/pages/HistoricoPedidos';
import UltimosPedidos from './shared/components/UltimosPedidos';
import PedidosProntos from './shared/components/PedidosProntos';
import PedidosEmPreparo from './shared/components/PedidosEmPreparo';
import GestaoEstabelecimento from './modules/administrador/pages/GestaoEstabelecimento';
import TelaCozinha from './modules/cozinha/pages/TelaCozinha';
import CarrinhoDeItens from './modules/cliente/components/Carrinho';
import ConfirmacaoPedido from './modules/caixa/pages/ConfirmacaoPedido';
import PainelPedidos from './modules/operador/pages/PainelPedidos';
import PainelDeControle from './modules/operador/pages/PainelControle';
import CadastroCliente from './auth/CadastroCliente';
import TipoEntrega from './modules/cliente/pages/TipoEntrega';
import PedidosCliente from './modules/cliente/pages/PedidosCliente';
import PageCategorias from './modules/cliente/pages/PageCategorias'
import ItensEstabelecimento from './modules/cliente/pages/ItensEstabelecimento';
import MesaEntrada from './modules/cliente/pages/MesaEntrada';
import AguardandoPagamento from './modules/caixa/pages/AguardandoPagamento';
import GerenciamentoPedidosMobile from './modules/administrador/pages/GerenciamentoPedidosMobile';
import RecuperarSenha from './auth/RecuperarSenha';
import RedefinirSenha from './auth/RedefinirSenha';
import HomeEquipe from './modules/operador/pages/HomeEquipe';
import Estoque from './modules/operador/pages/Estoque';
import PerfilEquipe from './modules/operador/pages/PerfilEquipe';
import Retirada from './modules/operador/pages/Retirada';
import Equipe from './modules/administrador/pages/Equipe';
import AtivarConta from './auth/AtivarConta';
import CadastroResponsavel from './modules/cliente/pages/CadastroResponsavel';
import EscolhaEstabelecimento from './modules/administrador/pages/Escolhaestabelecimento';
import PedidosEntrega from './modules/entregador/pages/PedidosEntrega';
import PerfilEntregador from './modules/entregador/pages/PerfilEntregador';

//Paginas após ações especificas

import VerMais from './modules/cliente/pages/VerMais';
import Configuracoes from './modules/administrador/pages/Configuracoes';
import WhatsappInbox from './modules/administrador/pages/WhatsappInbox';
import TaxasEntrega from './modules/administrador/pages/TaxasEntrega';
import ImpressaoAutomatica from './modules/administrador/pages/ImpressaoAutomatica';
import Fiscal from './modules/administrador/pages/Fiscal';
import MercadoPagoSucesso from './modules/caixa/pages/MercadoPagoSucesso';

// Páginas Master
import VisaoGeralMaster from './modules/speedhub/pages/VisaoGeralMaster';
import UniversidadesMaster from './modules/speedhub/pages/UniversidadesMaster';
import EstabelecimentosMaster from './modules/speedhub/pages/EstabelecimentosMaster';
import ClientesMaster from './modules/speedhub/pages/ClientesMaster';
import UsuariosMaster from './modules/speedhub/pages/UsuariosMaster';
import EquipeMaster from './modules/speedhub/pages/EquipeMaster';
import ItensMaster from './modules/speedhub/pages/ItensMaster';
import RelatoriosMaster from './modules/speedhub/pages/RelatoriosMaster';
import GerenciarEstabelecimento from './modules/speedhub/pages/GerenciarEstabelecimento';
import PagamentoFalhou from './modules/caixa/pages/PagamentoFalhou';

const GOOGLE_CLIENT_ID = "137816435367-115761n4s192dbv7ahs5juv3q4adu0uo.apps.googleusercontent.com";

function App() {
    console.log("API URL:", process.env.REACT_APP_API_URL); // <-- aqui
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <UsuariosProvider>
        <UniversidadesProvider>
          <EstabelecimentosProvider>
            <ProdutosProvider>
              <CategoriasProvider>
                <ClientesProvider>
                  <ResponsaveisProvider>
                    <ResponsavelAlunoProvider>
                  <PedidosProvider>
                    <ItensPedidosProvider>
                      <Router basename="/">
              <Routes>
                {/* Rota raiz: cada subdomínio mostra sua própria landing */}
                <Route exact path="/" element={(() => {
                  const area = getArea();
                  if (area === 'parceiro') return <EscolhaEstabelecimento />;
                  if (area === 'admin' || area === 'operador' || area === 'hub') return <Navigate to="/home" replace />;
                  return <Start />;
                })()} />

                {/* Login e recuperação de senha: acessíveis em qualquer subdomínio */}
                <Route path="/home" element={<Home />} />
                <Route path="/recuperarsenha" element={<RecuperarSenha/>} />
                <Route path="/redefinir-senha/:token" element={<RedefinirSenha/>} />
                <Route path="/ativar-conta" element={<AtivarConta/>} />

                {/* ================= parceiro.speedorder.com.br — captação de parceiros ================= */}
                <Route path="/escolha-estabelecimento" element={<AreaGate area="parceiro"><EscolhaEstabelecimento /></AreaGate>} />
                <Route path="/cadastroadmin" element={<AreaGate area="parceiro"><CadastroAdmin /></AreaGate>} />
                <Route path="/cadastroestabelecimento" element={<AreaGate area="parceiro"><CriarEstabelecimento /></AreaGate>} />

                {/* ================= cliente.speedorder.com.br ================= */}
                <Route path="/homecliente" element={<AreaGate area="cliente"><HomeCliente /></AreaGate>} />
                <Route path="/perfilcliente" element={<AreaGate area="cliente"><PerfilCliente /></AreaGate>} />
                <Route path="/cadastrocliente" element={<AreaGate area="cliente"><CadastroCliente /></AreaGate>} />
                <Route path="/pedidoscliente" element={<AreaGate area="cliente"><PedidosCliente /></AreaGate>} />
                <Route path="/homeprincipal" element={<AreaGate area="cliente"><HomePrincipal /></AreaGate>} />
                <Route path="/tipoentrega" element={<AreaGate area="cliente"><TipoEntrega /></AreaGate>} />
                <Route path="/pedidoclique/:id" element={<AreaGate area="cliente"><PedidoClique /></AreaGate>} />
                <Route path="/cadastroresponsavel" element={<AreaGate area="cliente"><CadastroResponsavel /></AreaGate>} />
                <Route path="/homeresponsavel" element={<AreaGate area="cliente"><HomeResponsavel /></AreaGate>} />
                <Route path="/categoria/:id" element={<AreaGate area="cliente"><PageCategorias /></AreaGate>} />
                <Route path="/historicopedido" element={<AreaGate area="cliente"><HistoricoPedidos /></AreaGate>} />
                <Route path="/historico-pedidos" element={<AreaGate area="cliente"><HistoricoPedidos /></AreaGate>} />
                <Route path="/estabelecimento/:id" element={<AreaGate area="cliente"><ItensEstabelecimento /></AreaGate>} />
                <Route path="/mesa/:token" element={<AreaGate area="cliente"><MesaEntrada /></AreaGate>} />
                <Route path="/vermais" element={<AreaGate area="cliente"><VerMais/></AreaGate>} />
                <Route path="/carrinhodeitens" element={<AreaGate area="cliente"><CarrinhoDeItens /></AreaGate>} />

                {/* ================= app.speedorder.com.br — painel do administrador ================= */}
                <Route path="/admin/gerenciamentopedidos" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <GerenciamentoPedidos />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/gestaoestabelecimento" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <GestaoEstabelecimento />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/configuracoes" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <Configuracoes />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/mercadopago-sucesso" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <MercadoPagoSucesso />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/equipe" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <Equipe />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/whatsapp" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <WhatsappInbox />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/taxas-entrega" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <TaxasEntrega />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/impressao" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <ImpressaoAutomatica />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/fiscal" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <Fiscal />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/cadastromesas" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <CadastroMesas />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/cadastrogarcons" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <CadastroGarcons />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/admin/gerenciamentocardapio" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <CadastroProdutos />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/personalizacaoloja" element={<AreaGate area="admin"><PersonalizacaoLoja /></AreaGate>} />
                <Route path="/gestao" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <GestaoEstabelecimentoMobile/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/gestaopedidos" element={
                  <AreaGate area="admin">
                    <ProtectedRoute requiredType="administrador">
                      <GerenciamentoPedidosMobile/>
                    </ProtectedRoute>
                  </AreaGate>
                } />

                {/* ================= operador.speedorder.com.br — equipe, cozinha e caixa ================= */}
                <Route path="/mesaparapedido" element={<AreaGate area="operador"><MesaParaPedido /></AreaGate>} />
                <Route path="/novopedido" element={<AreaGate area="operador"><NovoPedido /></AreaGate>} />
                <Route path="/equipe/novo-pedido" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <NovoPedido />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                {/* /chamadocozinha e /equipe/chamar-cozinha desativadas por enquanto —
                    ver ChamadoCozinha.jsx, componente continua no código pra religar depois */}
                <Route path="/equipe/mapa-mesas" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <MesaParaPedido />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/dashboard" element={<AreaGate area="operador"><Dashboard /></AreaGate>} />
                <Route path="/ultimos-pedidos" element={<AreaGate area="operador"><UltimosPedidos /></AreaGate>} />
                <Route path="/pedidos-prontos" element={<AreaGate area="operador"><PedidosProntos /></AreaGate>} />
                <Route path="/pedidos-em-preparo" element={<AreaGate area="operador"><PedidosEmPreparo /></AreaGate>} />
                <Route path="/pedidoconfirmado" element={<AreaGate area="operador"><ConfirmacaoPedido /></AreaGate>} />
                <Route path="/pagamento" element={<AreaGate area="operador"><ConfirmacaoPedido /></AreaGate>} />
                <Route path="/equipe/painelpedidos" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <PainelPedidos />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/equipe/paineldecontrole" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <PainelDeControle />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/telacozinha" element={<AreaGate area="operador"><TelaCozinha /></AreaGate>} />
                <Route path="/aguardando-pagamento" element={<AreaGate area="operador"><AguardandoPagamento /></AreaGate>} />
                <Route path="/pagamento-falhou" element={<AreaGate area="operador"><PagamentoFalhou /></AreaGate>} />
                <Route path="/sucesso" element={<AreaGate area="operador"><PedidoSucesso/></AreaGate>} />
                <Route path="/equipe/home-equipe" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <HomeEquipe/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/equipe/retirada" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <Retirada />
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/equipe/estoque" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <Estoque/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/equipe/perfil" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom">
                      <PerfilEquipe/>
                    </ProtectedRoute>
                  </AreaGate>
                } />

                {/* Entregador: mesmo login de Equipe (tipo "garcom"), função
                    "entregador" dentro dela — ver auth/Login.jsx e
                    shared/components/ProtectedRoute.jsx (requiredFuncao). */}
                <Route path="/equipe/entregador/pedidos" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom" requiredFuncao="entregador">
                      <PedidosEntrega/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/equipe/entregador/perfil" element={
                  <AreaGate area="operador">
                    <ProtectedRoute requiredType="garcom" requiredFuncao="entregador">
                      <PerfilEntregador/>
                    </ProtectedRoute>
                  </AreaGate>
                } />

                {/* ================= hub.speedorder.com.br — SpeedHub (master) ================= */}
                <Route path="/speedhub/visaogeral" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <VisaoGeralMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/universidades" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <UniversidadesMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/estabelecimentos" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <EstabelecimentosMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/clientes" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <ClientesMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/estabelecimento/:id" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <GerenciarEstabelecimento/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/usuarios" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <UsuariosMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/equipe" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <EquipeMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/itens" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <ItensMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />
                <Route path="/speedhub/relatorios" element={
                  <AreaGate area="hub">
                    <ProtectedRoute requiredType="administrador">
                      <RelatoriosMaster/>
                    </ProtectedRoute>
                  </AreaGate>
                } />

              </Routes>
                      </Router>
                    </ItensPedidosProvider>
                  </PedidosProvider>
                    </ResponsavelAlunoProvider>
                  </ResponsaveisProvider>
                </ClientesProvider>
              </CategoriasProvider>
            </ProdutosProvider>
          </EstabelecimentosProvider>
        </UniversidadesProvider>
      </UsuariosProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
